
import { Directive, HostListener, input, inject, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputMask]',
  standalone: true
})
export class InputMaskDirective {
  maskType = input.required<'phone' | 'citizen-id'>({ alias: 'appInputMask' });
  
  private el = inject(ElementRef);
  // FIX: Explicitly type control to NgControl | null to avoid unknown type inference
  private control: NgControl | null = inject(NgControl, { optional: true });

  @HostListener('input', ['$event'])
  onInput(event: InputEvent): void {
    const input = event.target as HTMLInputElement;
    let rawValue = input.value.replace(/\D/g, ''); // Remove non-digits
    let formattedValue = '';

    if (this.maskType() === 'phone') {
      // Format: 0XX-XXX-XXXX (10 digits)
      if (rawValue.length > 10) rawValue = rawValue.substring(0, 10);
      
      if (rawValue.length > 6) {
        formattedValue = `${rawValue.slice(0, 3)}-${rawValue.slice(3, 6)}-${rawValue.slice(6)}`;
      } else if (rawValue.length > 3) {
        formattedValue = `${rawValue.slice(0, 3)}-${rawValue.slice(3)}`;
      } else {
        formattedValue = rawValue;
      }
    } else if (this.maskType() === 'citizen-id') {
      // Format: X-XXXX-XXXXX-XX-X (13 digits)
      if (rawValue.length > 13) rawValue = rawValue.substring(0, 13);

      if (rawValue.length > 12) {
        formattedValue = `${rawValue.slice(0, 1)}-${rawValue.slice(1, 5)}-${rawValue.slice(5, 10)}-${rawValue.slice(10, 12)}-${rawValue.slice(12)}`;
      } else if (rawValue.length > 10) {
        formattedValue = `${rawValue.slice(0, 1)}-${rawValue.slice(1, 5)}-${rawValue.slice(5, 10)}-${rawValue.slice(10)}`;
      } else if (rawValue.length > 5) {
        formattedValue = `${rawValue.slice(0, 1)}-${rawValue.slice(1, 5)}-${rawValue.slice(5)}`;
      } else if (rawValue.length > 1) {
        formattedValue = `${rawValue.slice(0, 1)}-${rawValue.slice(1)}`;
      } else {
        formattedValue = rawValue;
      }
    }

    // Update the input element
    input.value = formattedValue;

    // Update the Angular Form Control (if attached)
    if (this.control && this.control.control) {
      this.control.control.setValue(formattedValue, { emitEvent: false });
    }
  }
}
